import { types, QuoteAppsAction } from './actions';
import { QuoteAppsPanelState } from './constants';
import { AppPanelMetaMap } from './types';

interface QuoteAppsState {
  appsPanelState: QuoteAppsPanelState | null;
  meta: Partial<AppPanelMetaMap>;
}

const initialState: QuoteAppsState = {
  appsPanelState: null,
  meta: {},
};

export const reducer = (
  state: QuoteAppsState = initialState,
  action: QuoteAppsAction,
): QuoteAppsState => {
  switch (action.type) {
    case types.SET_QUOTE_APPS_PANEL_STATE: {
      const { appsPanelState, meta } = action.payload;

      // Update meta for the specific app type if provided
      const updatedMetaByType =
        meta && appsPanelState
          ? { ...state.meta, [appsPanelState]: meta }
          : state.meta;

      return {
        ...state,
        appsPanelState,
        meta: updatedMetaByType,
      };
    }

    case types.UPDATE_APP_META:
      return {
        ...state,
        meta: {
          ...state.meta,
          [action.payload.appType]: action.payload.meta,
        },
      };
    default:
      return state;
  }
};

interface RootState {
  modules?: {
    quotes?: {
      quoteItems?: {
        apps?: QuoteAppsState;
      };
    };
  };
}

export const getQuoteAppsPanelState = (
  state: RootState,
): QuoteAppsPanelState | null =>
  state.modules?.quotes?.quoteItems?.apps?.appsPanelState ?? null;

// Get meta for a specific app type
export const getQuoteAppMetaForType = <T extends QuoteAppsPanelState>(
  state: RootState,
  appType: T,
): AppPanelMetaMap[T] | null =>
  (state.modules?.quotes?.quoteItems?.apps?.meta?.[
    appType
  ] as AppPanelMetaMap[T]) ?? null;
